'use strict';

import { Company } from '../Company';
import { Entity } from '../Entity';
import { Plan } from '../Plan';
import { User } from './User';
import { UserCommissionSchedule } from './UserCommissionSchedule';

import { UserCommissionScheduleCollection } from '../../Collections/User/UserCommissionScheduleCollection';

export class UserCommission extends Entity {
  protected id;
  protected user: User;
  protected company: Company;
  protected plan: Plan;

  protected schedules: UserCommissionScheduleCollection;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;

    if (data.user) {
      const user = new User();
      user.hydrate(data.user);

      this.user = user;
    }

    if (data.company) {
      const company = new Company();
      company.hydrate(data.company);

      this.company = company;
    }

    if (data.plan) {
      const plan = new Plan();
      plan.hydrate(data.plan);

      this.plan = plan;
    }

    if (data.schedules) {
      const schedules = new UserCommissionScheduleCollection();

      data.schedules.forEach((singleDocumentData) => {
        const schedule = new UserCommissionSchedule();
        schedule.hydrate(singleDocumentData);

        schedules.addItem(schedule);
      });

      this.schedules = schedules;
    }
  }

  public getId() {
    return this.id;
  }

  public getUser() {
    return this.user;
  }

  public getCompany() {
    return this.company;
  }

  public getPlan() {
    return this.plan;
  }

  public getSchedules() {
    return this.schedules;
  }
}
